import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { Translate, TextFormat, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './vehicle-position-last.reducer';
import { IVehiclePositionLast } from 'app/shared/model/vehicle-position-last.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, DEFAULT_ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const VehiclePositionLast = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const vehiclePositionLastList = useAppSelector(state => state.vehiclePositionLast.entities);
  const loading = useAppSelector(state => state.vehiclePositionLast.loading);
  const totalItems = useAppSelector(state => state.vehiclePositionLast.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <h2 id="vehicle-position-last-heading" data-cy="VehiclePositionLastHeading">
        <Translate contentKey="fleetSenseApp.vehiclePositionLast.home.title">Vehicle Position Lasts</Translate>
        <div className="d-flex justify-content-end">
          <Button className="mr-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="fleetSenseApp.vehiclePositionLast.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="fleetSenseApp.vehiclePositionLast.home.createLabel">Create new Vehicle Position Last</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {vehiclePositionLastList && vehiclePositionLastList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('created')}>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.created">Created</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('latitude')}>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.latitude">Latitude</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('longitude')}>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.longitude">Longitude</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('odometer')}>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.odometer">Odometer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('speed')}>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.speed">Speed</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('vBat')}>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.vBat">V Bat</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('vSupply')}>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.vSupply">V Supply</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('supplyOn')}>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.supplyOn">Supply On</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('activated')}>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.activated">Activated</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.truckImplement">Truck Implement</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.company">Company</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.vehiclePositionLast.user">User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {vehiclePositionLastList.map((vehiclePositionLast, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${vehiclePositionLast.id}`} color="link" size="sm">
                      {vehiclePositionLast.id}
                    </Button>
                  </td>
                  <td>{vehiclePositionLast.created ? <TextFormat type="date" value={vehiclePositionLast.created} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{vehiclePositionLast.latitude}</td>
                  <td>{vehiclePositionLast.longitude}</td>
                  <td>{vehiclePositionLast.odometer}</td>
                  <td>{vehiclePositionLast.speed}</td>
                  <td>{vehiclePositionLast.vBat}</td>
                  <td>{vehiclePositionLast.vSupply}</td>
                  <td>{vehiclePositionLast.supplyOn}</td>
                  <td>{vehiclePositionLast.activated ? 'true' : 'false'}</td>
                  <td>
                    {vehiclePositionLast.truckImplement ? (
                      <Link to={`truck-implement/${vehiclePositionLast.truckImplement.id}`}>{vehiclePositionLast.truckImplement.licensePlate}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{vehiclePositionLast.company ? <Link to={`company/${vehiclePositionLast.company.id}`}>{vehiclePositionLast.company.name}</Link> : ''}</td>
                  <td>{vehiclePositionLast.user ? vehiclePositionLast.user.login : ''}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${vehiclePositionLast.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${vehiclePositionLast.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${vehiclePositionLast.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.vehiclePositionLast.home.notFound">No Vehicle Position Lasts found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={vehiclePositionLastList && vehiclePositionLastList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default VehiclePositionLast;
